import React from "react";
import { useNavigate } from "react-router-dom";
import '../assets/styles/Portfolio.scss';
import projects from "../data/projects";

function Portfolio() {
  const navigate = useNavigate();

  return (
    <div className="container" id="portfolio">
      <div className="portfolio-container">
        <div className="portfolio-header">
          <span className="portfolio-tag">{'// Selected Work'}</span>
          <h1>Architecture that ships.</h1>
          <p className="portfolio-intro">
            Cloud infrastructure and platform engineering engagements. Client details anonymized.
          </p>
        </div>
        <div className="portfolio-grid">
          {projects.map((project, index) => (
            <div
              className="portfolio-card"
              key={index}
              onClick={() => navigate(`/project/${project.slug}`)}
              role="button"
              tabIndex={0}
              onKeyDown={(e) => e.key === "Enter" && navigate(`/project/${project.slug}`)}
            >
              {project.diagram ? (
                <img
                  src={project.diagram}
                  alt={project.title}
                  className="portfolio-card-image"
                />
              ) : (
                <div className="portfolio-card-placeholder" />
              )}
              <div className="portfolio-card-overlay">
                <div className="portfolio-card-info">
                  <span className="portfolio-card-category">{project.category}</span>
                  <h2 className="portfolio-card-title">{project.title}</h2>
                </div>
                <span className="portfolio-card-cta">View Case Study →</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default Portfolio;
